import React, {useState} from 'react';

import {withRouter} from 'react-router';

import {createFormErrorsContext, FormErrorsProps} from 'app/general/forms';
import {MainContentContainer} from 'app/general/structures/MainContentContainer';
import {SPPage} from 'app/general/structures/SPPage';
import {useKnowledgeBase} from 'app/kbs/api';
import {EditableKBMetadata} from 'app/kbs/components/KBEditPage/EditableKbMetadata';
import {KBEditPageActionsButton} from 'app/kbs/components/KBEditPage/KBEditPageActionsButton';
import {DocumentPresenceMembers} from 'app/presence/components/DocumentPresenceMembers';
import {getObjectName} from 'app/utils/fallbacks';
import {gt} from 'app/utils/i18n';

import {KBTree} from './KBTree';

import type {WithRouterProps} from 'react-router';

type Props = FormErrorsProps & WithRouterProps<{hashid: string}, unknown>;

export const KBEditPage = createFormErrorsContext(
  withRouter(({params}: Props) => {
    const [editingMetadata, setEditingMetadata] = useState(false);
    const {data: kb} = useKnowledgeBase({kb_id: params.hashid});

    return (
      <SPPage
        pageTitle={gt('%(name)s | Editing', {name: kb?.name})}
        horizontalPadding={false}
        breadcrumbProps={{docName: getObjectName(kb?.name, 'knowledgebase')}}
        actionArea={kb && <KBEditPageActionsButton kb={kb} />}
      >
        {kb && (
          <>
            <DocumentPresenceMembers
              contentType="knowledgebase"
              objectId={kb.id}
              pageContext="edit"
            />
            <EditableKBMetadata
              setEditing={(editing) => setEditingMetadata(editing)}
              editing={editingMetadata}
            />
            <MainContentContainer>
              <KBTree kb={kb} />
            </MainContentContainer>
          </>
        )}
      </SPPage>
    );
  })
);
